import { API_ENDPOINTS } from "./apiCall";
const BASE = `${API_ENDPOINTS.API_COMMAN_URL}AllDashboard/`;

export const DASHBOARD_API_ENDPOINTS = {
  dashboard: {
    production_summary: `${BASE}production-dashboard`,   
    production_summary_grade_wise_reel: `${BASE}production-dashboard-grade-wise-reel-count`, 
  }

};

